import { Component, forwardRef, OnInit } from '@angular/core';
import {
  ControlValueAccessor,
  FormBuilder,
  FormGroup,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { SisifoUser } from '@app/core/users';

@Component({
  selector: 'afoone-sisifo-user',
  templateUrl: './sisifo-user.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SisifoUserComponent),
      multi: true,
    },
  ],
})
export class SisifoUserComponent implements ControlValueAccessor, OnInit {
  public value: SisifoUser; // Internal value for binding

  public form: FormGroup;
  private onChange: (val: any) => any;
  private onTouch: () => any;

  constructor(fb: FormBuilder) {
    this.form = fb.group({
      arztNr: [''],
      centers: [[]],
    });
  }

  ngOnInit(): void {
    this.form.valueChanges.subscribe((value) => {
      if (!this.onChange) {
        return;
      }
      this.onChange(value);
    });
  }

  writeValue(obj: any): void {
    if (obj) {
      this.form.patchValue(obj);
    } else {
      this.form.reset();
    }
  }
  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.form.disable();
    } else {
      this.form.enable();
    }
  }
}
